/* eslint-disable react/prop-types */
import React, { useState, useEffect, useRef, createRef } from "react"; // React Stuff
import { BrowserView, MobileView } from "react-device-detect"; // Device Detection for two views
import withRouter from "../WithRouter";
// Common
import FadeIn from "../common/FadeIn";
import StatusBlock from "../common/StatusBlock";
import ReturnButton from "../common/ReturnButton";
//Packages
import axios from "axios";
import { Container, Tabs, Tab, Col, Row, Form, Button } from "react-bootstrap";
import { isAuthenticated } from "./services/auth"; //import auth
import { Navigate, Link } from "react-router-dom";
//Subcomponents
import SetTutor from "./page-parts/SetTutor";
import BlockInfo from "./page-parts/BlockInfo";
import BlockParticipants from "./page-parts/BlockParticipants";
import BlockUpdate from "./page-parts/BlockUpdate";
import BlockIssueReports from "./page-parts/BlockIssueReports";
import BlockDelete from "./page-parts/BlockDelete";
import LoadingSpinner from "../LoadingSpinner";

const BlockClassManage = (props) => {
  const [blockData, setBlockData] = useState({});
  const [tutors, setTutors] = useState([]);
  const [classTypes, setClassTypes] = useState([]);
  const [viewMode, setViewMode] = useState("classinfo");
  // Handle Clicks, Submits, Errors
  const [submitClicked, setSubmitClicked] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  // Extract the class ID
  const blockid = props.params.blockid;
  const prevBlockId = useRef(); //Reference the previous class ID to ensure new get request if it changes.
  // Get the class data and set it
  useEffect(async () => {
    prevBlockId.current = blockid; // Assign Refs Value to current load
    // Get the Class Data
    const blockDataRequest = await axios.get(`/api/admin/manage/blocks/${blockid}`, {
      withCredentials: true,
    });
    // Get the List of Tutors for Setting
    const tutorListRequest = await axios.get(`/api/admin/manage/tutor`, {
      withCredentials: true,
    });
    // Get the Class Types for Settings
    const classTypeRequest = await axios.get(`/api/admin/manage/class_types`, {
      withCredentials: true,
    });
    setClassTypes(classTypeRequest.data);
    setTutors(tutorListRequest.data);
    return setBlockData(blockDataRequest.data);
  }, [blockid]); // Run useEffect when the classID changes to get new class data.

  //Fetch new data if a subcomponent calls for it.
  const fetchNewData = async () => {
    const blockDataRequest = await axios.get(`/api/admin/manage/blocks/${blockid}`, {
      withCredentials: true,
    });
    return setBlockData(blockDataRequest.data);
  };

  // CreateRef to handle Alerts and scroll
  const alerts = createRef();
  const scrollSmoothHandler = () => {
    return alerts.current.scrollIntoView({ behavior: "smooth" });
  };

  // Dismiss Message
  const dismissMessages = () => {
    setSuccessMessage("");
    return setErrorMessage("");
  };

  return (
    <div className='ClassList' key={blockid}>
      <FadeIn delay={250} duration={450}>
        {isAuthenticated() ? (
          <Container>
            <div ref={alerts}>
              <StatusBlock
                errorMessage={errorMessage}
                successMessage={successMessage}
                dismissMessages={dismissMessages}
              />
            </div>
            {blockData._id ? (
              <>
                <BrowserView>
                  <Tabs defaultActiveKey='classinfo' id='uncontrolled-tabs' className='text-center'>
                    <Tab eventKey='classinfo' title='Overview'>
                      <BlockInfo data={blockData} />
                    </Tab>
                    <Tab eventKey='tutor' title='Tutor'>
                      <SetTutor
                        data={blockData}
                        tutors={tutors}
                        fetchNewData={fetchNewData}
                        submitClicked={submitClicked}
                        setSubmitClicked={setSubmitClicked}
                        setErrorMessage={setErrorMessage}
                        setSuccessMessage={setSuccessMessage}
                        BookingType='block'
                      />
                    </Tab>
                    <Tab eventKey='participants' title='Participants/Bookings'>
                      <BlockParticipants
                        data={blockData}
                        fetchNewData={fetchNewData}
                        submitClicked={submitClicked}
                        setSubmitClicked={setSubmitClicked}
                        setErrorMessage={setErrorMessage}
                        setSuccessMessage={setSuccessMessage}
                      />
                    </Tab>
                    <Tab eventKey='edit' title='Edit Details'>
                      <BlockUpdate
                        scrollSmoothHandler={scrollSmoothHandler}
                        data={blockData}
                        classTypes={classTypes}
                        fetchNewData={fetchNewData}
                        submitClicked={submitClicked}
                        setSubmitClicked={setSubmitClicked}
                        setErrorMessage={setErrorMessage}
                        setSuccessMessage={setSuccessMessage}
                      />
                    </Tab>
                    <Tab eventKey='register' title='Register'>
                      <BlockRegisterTab _id={blockData._id} />
                    </Tab>
                    <Tab eventKey='progress' title='Progress &amp; Awards'>
                      <BlockIssueReports data={blockData} />
                    </Tab>
                    <Tab eventKey='delete' title='Delete Block'>
                      <BlockDelete
                        data={blockData}
                        submitClicked={submitClicked}
                        setSubmitClicked={setSubmitClicked}
                        setErrorMessage={setErrorMessage}
                        setSuccessMessage={setSuccessMessage}
                      />
                    </Tab>
                  </Tabs>
                </BrowserView>
                <MobileView>
                  <ModeSelect viewMode={viewMode} setViewMode={setViewMode} />
                  {viewMode === "classinfo" && (
                    <FadeIn delay={250} duration={450}>
                      <BlockInfo data={blockData} />
                    </FadeIn>
                  )}
                  {viewMode === "tutor" && (
                    <FadeIn delay={250} duration={450}>
                      <SetTutor
                        data={blockData}
                        tutors={tutors}
                        fetchNewData={fetchNewData}
                        submitClicked={submitClicked}
                        setSubmitClicked={setSubmitClicked}
                        setErrorMessage={setErrorMessage}
                        setSuccessMessage={setSuccessMessage}
                        BookingType='block'
                      />
                    </FadeIn>
                  )}
                  {viewMode === "participants" && (
                    <FadeIn delay={250} duration={450}>
                      <BlockParticipants
                        data={blockData}
                        fetchNewData={fetchNewData}
                        submitClicked={submitClicked}
                        setSubmitClicked={setSubmitClicked}
                        setErrorMessage={setErrorMessage}
                        setSuccessMessage={setSuccessMessage}
                      />
                    </FadeIn>
                  )}
                  {viewMode === "register" && (
                    <FadeIn delay={250} duration={450}>
                      <BlockRegisterTab _id={blockData._id} />
                    </FadeIn>
                  )}
                  {viewMode === "progress" && (
                    <FadeIn delay={250} duration={450}>
                      <BlockIssueReports data={blockData} />
                    </FadeIn>
                  )}
                  {viewMode === "edit" && (
                    <FadeIn delay={250} duration={450}>
                      <BlockUpdate
                        scrollSmoothHandler={scrollSmoothHandler}
                        data={blockData}
                        classTypes={classTypes}
                        fetchNewData={fetchNewData}
                        submitClicked={submitClicked}
                        setSubmitClicked={setSubmitClicked}
                        setErrorMessage={setErrorMessage}
                        setSuccessMessage={setSuccessMessage}
                      />
                    </FadeIn>
                  )}
                  {viewMode === "delete" && (
                    <FadeIn delay={250} duration={450}>
                      <BlockDelete
                        data={blockData}
                        submitClicked={submitClicked}
                        setSubmitClicked={setSubmitClicked}
                        setErrorMessage={setErrorMessage}
                        setSuccessMessage={setSuccessMessage}
                      />
                    </FadeIn>
                  )}
                </MobileView>
                <Row>
                  <Col className='text-center' sm='12'>
                    <ReturnButton />
                  </Col>
                </Row>
              </>
            ) : (
              <LoadingSpinner />
            )}
          </Container>
        ) : (
          <Navigate to='/admin/' />
        )}
      </FadeIn>
    </div>
  );
};

const BlockRegisterTab = (props) => {
  const blockID = props._id;
  return (
    <Row className='mt-5 mb-3 text-center'>
      <Col sm='12' className='border shadow p-3'>
        <h3 className='mt-4'>Registers</h3>
        <p>
          Registers for block classes are generated at block creation and persist for the lifecycle
          of the block. When you change dates, the dates on the register will automatically change
          to match your new dates.
        </p>
        <Row>
          <Col className='border'>
            <Button
              variant='success'
              className='mb-3 mt-3'
              type='link'
              size="lg"
              as={Link}
              to={`/admin/block-registers/${blockID}`}
            >
              Go to Register
            </Button>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

const ModeSelect = (props) => {
  return (
    <Row>
      <Col>
        <Form className='mt-3 text-center'>
          <Form.Label>Choose Tab</Form.Label>
          <Form.Control
            as='select'
            value={props.viewMode}
            onChange={(e) => props.setViewMode(e.target.value)}
            custom
            className='border'
          >
            <option value='' disabled defaultValue>
              Select Option
            </option>
            <option value='classinfo'>Info</option>
            <option value='tutor'>Tutor</option>
            <option value='participants'>Participants/Bookings</option>
            <option value='register'>Registers</option>
            <option value='edit'>Edit Class</option>
            <option value='progress'>Progress &amp; Awards</option>
            <option value='delete'>Delete Class</option>
          </Form.Control>
        </Form>
      </Col>
    </Row>
  );
};

export default withRouter(BlockClassManage);
